module.exports = __webpack_public_path__ + "img/arrow_down_3.99e902a9.svg";